import React from 'react';
import AdMessage from '../../../../SpecialMessage/messages/FacebookMessage/components/AdMessage';
const FacebookPostback = ({ message }) => {
    return React.createElement("div", null, message.referral && React.createElement(AdMessage, { referral: message.referral }));
};
export default FacebookPostback;
